import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Configuração personalizada para usar sessionStorage em vez de localStorage
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // IMPORTANTE: manter 'implicit'. Com 'pkce' o link de redefinição de senha
    // depende de um code_verifier gravado no storage no momento em que o e-mail
    // foi solicitado. Como a sessão vive em sessionStorage (isolado por aba) e o
    // usuário abre o link em outra aba — ou em outro dispositivo — o verifier
    // não está disponível e a troca do code por sessão falha silenciosamente.
    // No fluxo implícito o token volta no fragmento da URL e funciona em
    // qualquer aba/dispositivo. Ver src/pages/login/RedefinirSenha.tsx.
    flowType: 'implicit',
    storage: {
      getItem: (key) => {
        const value = sessionStorage.getItem(key);
        return value;
      },
      setItem: (key, value) => {
        sessionStorage.setItem(key, value);
      },
      removeItem: (key) => {
        sessionStorage.removeItem(key);
      }
    }
  },
  global: {
    headers: {
      'X-Client-Info': 'gravi-aguas-web'
    }
  }
}); 